

//export const base_url = 'http://localhost:1340'
//export const img_base_url = 'http://localhost:1340'
//export const est_stricte = false

//export const base_url = 'http://192.168.0.169:1337'  //MTN ROUTEUR
////////===export const base_url = 'https://resto-prl.herokuapp.com'  //HEROKU

//EVOLUTIO TEST
//export const base_url = 'https://resto-back.evolutiosystem.com'  //evolution SYSTEM
//export const img_base_url = 'https://resto-back.evolutiosystem.com'  //evolution SYSTEM IMAGE URL FOR SAILS SERVER

/////export const base_url = 'http://192.168.10.49:1337'  //MOOV ROUTEUR

//////////LOCAL
//export const base_url = 'http://192.168.10.55:1337'  //MOOV ROUTEUR new pc
//export const img_base_url = 'http://192.168.10.55:1337'  //IMAGE URL FOR SAILS SERVER

export const img_server = 'SAILS'  // EXPRESS or SAILS
//////export const base_url = 'http://192.168.43.55:1338'  //MOOV ROUTEUR   PC SAMI

//export const base_url = ' https://jdd-perlene.herokuapp.com'

// const base_url = ' https://jdd-test.herokuapp.com'
//export const base_url ='http://logicielperlene.com/app'

////export const img_base_url = 'http://192.168.10.49:5000'  //IMAGE URL FOR EXPRESS



//TEST
//export const base_url = 'https://resto-back.evolutiosystem.com'
///export const img_base_url = 'https://resto-img.evolutiosystem.com'  //IMAGE URL FOR ONLINE SERVER
//export const img_base_url = 'https://resto-back.evolutiosystem.com'  //IMAGE URL FOR ONLINE SERVER

// LA MARTINE
//export const base_url = 'https://martine-back.perlenerestaurant.com'//'https://martine-back.evolutiosystem.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://martine-back.perlenerestaurant.com'  //IMAGE URL FOR ONLINE SERVER

// VAL DE DICK CLIB HOTEL
//export const base_url = 'https://vdc-hotel-back.perlenerestaurant.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://vdc-hotel-back.perlenerestaurant.com'  //IMAGE URL FOR ONLINE SERVER

// VAL DE DICK CLIB JARDINS
//export const base_url = 'https://vdc-jardins-back.perlenerestaurant.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://vdc-jardins-back.perlenerestaurant.com'  //IMAGE URL FOR ONLINE SERVER

// VAL DE DICK CLIB ROOFTOP
//export const base_url = 'https://vdc-rooftop-back.perlenerestaurant.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://vdc-rooftop-back.perlenerestaurant.com'  //IMAGE URL FOR ONLINE SERVER

// VAL DE DICK CLIB VIP
//export const base_url = 'https://vdc-vip-back.perlenerestaurant.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://vdc-vip-back.perlenerestaurant.com'  //IMAGE URL FOR ONLINE SERVER


// VAL DE DICK CLIB JARDINS LOCAL
//export const base_url = 'http://192.168.88.48:1340'  //MOOV ROUTEUR new pc
//export const img_base_url = 'http://192.168.88.48:1340'  //IMAGE URL FOR ONLINE SERVER

// PRL DG DEMO
//export const base_url = 'https://prldg-back.perlenerestaurant.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://prldg-back.perlenerestaurant.com'  //IMAGE URL FOR ONLINE SERVER

// ESPACE WAXO
///export const base_url = 'https://waxo-back.perlenerestaurant.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://waxo-back.perlenerestaurant.com'  //IMAGE URL FOR ONLINE SERVER

// ACROPLOE
//export const base_url = 'https://acropole-back.perlenedg.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://acropole-back.perlenedg.com'  //IMAGE URL FOR ONLINE SERVER
//export const est_stricte = true
//export const estTva = true  // PARAMETRAGE TVA - true pour activer le calcul de TVA, false pour désactiver


// ACROPLOE 2 POUR LE NOUVEAU
//export const base_url = 'https://acropole-back.perlenecommande.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://acropole-back.perlenecommande.com'  //IMAGE URL FOR ONLINE SERVER
//export const est_stricte = true

// ACROPLOE  3 EVOLUTIO SYSTE:
export const base_url = 'https://acropole-back.evolutiosystem.com'  //MOOV ROUTEUR new pc
export const img_base_url = 'https://acropole-back.evolutiosystem.com'  //IMAGE URL FOR ONLINE SERVER
export const est_stricte = true
export const estTva = false  // PARAMETRAGE TVA - true pour activer le calcul de TVA, false pour désactiver

// LA BOUFFETE
//export const base_url = 'https://labouffete-back.perlenecommande.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://labouffete-back.perlenecommande.com'  //IMAGE URL FOR ONLINE SERVER
//export const est_stricte = false

// FOOD MOOD
//export const base_url = 'https://foodmood-back.perlenedg.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://foodmood-back.perlenedg.com'  //IMAGE URL FOR ONLINE SERVER


// FOOD MOOD
//export const base_url = 'https://perlene-back.perlenecommande.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://perlene-back.perlenecommande.com'  //IMAGE URL FOR ONLINE SERVER

// PERLENE CMD TOGO
//export const base_url = 'https://perlenetg-back.perlenecommande.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://perlenetg-back.perlenecommande.com'  //IMAGE URL FOR ONLINE SERVER
//export const est_stricte = true

// LA PERFECTION TOGO
//export const base_url = 'https://laperfection-back.perlenecommande.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://laperfection-back.perlenecommande.com'  //IMAGE URL FOR ONLINE SERVER
//export const est_stricte = falser

// MIDEN
//export const base_url = 'https://miden-back.perlenecommande.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://miden-back.perlenecommande.com'  //IMAGE URL FOR ONLINE SERVER
//export const est_stricte = true

// VODOUN BAR
//export const base_url = 'https://vodounbar-back.perlenecommande.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://vodounbar-back.perlenecommande.com'  //IMAGE URL FOR ONLINE SERVER
//export const est_stricte = true

// WISKY LIBRARY
//export const base_url = 'https://whiskylibrary-back.perlenecommande.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://whiskylibrary-back.perlenecommande.com'  //IMAGE URL FOR ONLINE SERVER
//export const est_stricte = true

// LE TWINS
//export const base_url = 'https://letwins-back.perlenecommande.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://letwins-back.perlenecommande.com'  //IMAGE URL FOR ONLINE SERVER
//export const est_stricte = false

// LE NIRVANA
//export const base_url = 'https://lenirvana-back.perlenecommande.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://lenirvana-back.perlenecommande.com'  //IMAGE URL FOR ONLINE SERVER
//export const est_stricte = false

// HOTEL RESIDENCE DIVINE
//export const base_url = 'https://hrd-back.perlenecommande.com'  //MOOV ROUTEUR new pc
//export const img_base_url = 'https://hrd-back.perlenecommande.com'  //IMAGE URL FOR ONLINE SERVER
//export const est_stricte = true
//export const estTva = true  // PARAMETRAGE TVA - true pour activer le calcul de TVA, false pour désactiver